import { IChallenges } from "../../ISearch";

export const challengesSv: Array<IChallenges> = [
  {
    title: "Viktspurten",
    href: "/se/viktspurten",
    imageSrc: {
      desktop:
        "https://i.dietdoctor.com/wp-content/uploads/2023/01/viktspurten_deskop.png?auto=compress%2Cformat",
      mobile:
        "https://i.dietdoctor.com/wp-content/uploads/2023/01/viktspurten_mobile-1.png?auto=compress%2Cformat"
    }
  },
  {
    title: "Viktnedgång 2.0",
    href: "/se/viktnedang-10-veckor-2",
    imageSrc: {
      desktop:
        "https://www.dietdoctor.com/wp-content/uploads/2022/10/viktnedgang-desktop.png?auto=compress%2Cformat",
      mobile:
        "https://www.dietdoctor.com/wp-content/uploads/2022/10/viktnedgang-mobile.png?auto=compress%2Cformat"
    }
  }
];
